import 'Sass/views/getting-started-guide.scss';

(function () {
    'use strict';

    function gettingStartedGuide($q, $timeout, contentService) {

        // fetch the root guide element and its data attributes
        // set up the content service query object
        // guide model data is retrieved directly from a variable loaded on the page in the view
        var root = document.getElementById('guideRoot'),
            guidesModel = JSON.parse(guidesJson),
            guides = [],
            deferred = $q.defer(),
            q = {
                searchType: 'SearchSearcher',
                fields: ['bodyText', 'pointerBox', 'stepSummary'],
                contentTypes: ['GettingStartedItem'],
                html: true,
                count: 1
            };

        this.stepLabels = root.hasAttribute('data-steplabels') ? root.data.steplabels.split(',') : [];
        this.guideNames = [];

        angular.forEach(guidesModel.Guides, (v, i) => {
            // filter to ensure the correct value is returned - object isn't ordered
            this.guideNames.push({ index: i, name: v.GuideLabel });

            const steps = v.Steps;

            guides.push(
                steps.map(
                    s => s.Links
                )
            );
        });

        const pageQuery = v => {
            q.query = {
                '__Key': v
            };

            return contentService.get(q)
                .then(resp => resp);
        }

        // timeout triggers digest cycle
        const setData = data => {
            $timeout(() => {

                this.content = '';

                let c = '';

                angular.forEach(data, v => {
                    c += v[0].bodyText;
                });

                this.pointer = data[0][0].pointerBox;
                this.summary = data[0][0].stepSummary;
                this.content = c;

                root.classList.remove('loading');
            });
        }

        // chain the requests for multiple nodes
        // set the displayed data when all have returned
        // id can be a single id or pipe-delimited list
        // only the first pointer and summary are displayed - allows using multiple nodes in a step to aid content reuse
        const getGuidePage = () => {

            $q.all(this.currentGuide[this.currentPage].map(pageQuery))
                .then(data => {
                    $timeout(() => {
                        deferred.resolve();
                        setData(data);
                    });
                });
        }

        // set the current page to 0
        // fetch the correct guide based on the current selected index
        // send request for the first page of the current guide
        const getGuide = item => {
            // if using the typeahead, need to set the guideindex value
            if (item) {
                this.guideIndex = item.index;
            }

            loadingClass();
            // convert udi to key for search
            this.currentGuide = guides[this.guideIndex].map(v => v.map(vv =>
                vv.Udi.replace('umb://document/', '').replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5')));

            this.currentPage = 0;
            getGuidePage();
        }

        // increment the current page
        // send request for the current page of the current guide
        const next = () => {
            loadingClass();
            this.currentPage = this.currentPage + 1 <= this.currentGuide.length ? this.currentPage += 1 : 0;
            getGuidePage();
        }

        // for the parameter i, set the current page and fetch the corresponding guide page
        const getPage = i => {
            if (i !== this.currentPage) {
                loadingClass();
                this.currentPage = i;
                getGuidePage();
            }
        }

        // set the progress bar block class based on the current progress through the guide
        // class will be complete|active|done plus either first|last for the first and last child - using :first|last-child psuedo selectors lags 
        // complete: all steps set to complete when the final guide page is loaded
        // active: the current page
        // done: any page where the index is lower than the current page
        const barClass = i => {

            let str = '';

            if (this.currentPage + 1 === this.currentGuide.length) {
                str = 'complete';
            } else if (this.currentPage === i) {
                str = 'active';
            } else if (this.currentPage > i) {
                str = 'done';
            }

            return str + (i === 0 ? ' first' : '') + (i + 1 === this.currentGuide.length ? ' last' : '');
        }

        const loadingClass = () => root.classList.add('loading');

        // the public api
        angular.extend(this, {
            currentGuide: [],
            currentPage: 0,
            progress: 0,
            content: '',

            getGuide: getGuide,
            getPage: getPage,
            barClass: barClass,
            next: next
        });
    }

    angular.module('Uscapp').controller('gettingStartedGuideCtrl', ['$q', '$timeout', 'contentService', gettingStartedGuide]);
}());